import { render, staticRenderFns } from "./PhotovoltaicBenefits.vue?vue&type=template&id=29c59830&scoped=true"
import script from "./PhotovoltaicBenefits.vue?vue&type=script&lang=js"
export * from "./PhotovoltaicBenefits.vue?vue&type=script&lang=js"
import style0 from "./PhotovoltaicBenefits.vue?vue&type=style&index=0&id=29c59830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c59830",
  null
  
)

export default component.exports